<template>
  <div class="row m-0 ">

    <img class="d-block col-lg-1 col-md-6 col-sm-12 fit rounded-3 p-0 imgSize" :src="img">

    <div class="col-lg-7 col-md-6 col-sm-12">
      <span class="text-custom-text">{{ title }}</span>
      <div class="mt-1"></div>
      <div class="d-flex grid-gap">
        <div v-for="(item, index) in tag_list" :key="index">
          <TagItem :text="item.text" :color="item.color"></TagItem>
        </div>
      </div>
    </div>

    <div class="col-lg-2 col-sm-6 col-6">
      <span class="text-custom-description font-weight-500">x{{ amount }}</span>
      <p class="text-custom-text font-weight-500 font-size-16">{{ formPrice(price_data) }}</p>
    </div>

    <div class="text-right col-lg-2 col-sm-6 col-6">
      <span class="text-custom-text font-weight-500 font-size-12 mr-1">預估到貨時間</span>
      <span
          class="text-main-color font-weight-500">{{ delivery_time }}</span>
      <div class="mt-1"></div>
      <div>
        <base-button tag="a" type="white" size="sm" href="" class="px-3 text-main-color"
                     role="button"
                     aria-pressed="true"
                     data-toggle="modal"
                     :data-target="'#'+selectorDialog"
                     v-text="'查看細節'"
        />

      </div>
    </div>
    <OrderDialogItem
       :dataTarget="selectorDialog"
      :title="title"
      :note="note"
      :img="img"
      :tag_list="tag_list"
      :total_price="total_price"
      :price="price"
      :discount="discount"
      :combine_buy_discount="combine_buy_discount"
      :combine_buy_amount="combine_buy_amount"
      :exchange_rate="exchange_rate"
      :decrease="decrease"
      :stock="stock"
      :actual_stock="actual_stock"
      :history_list="history_list"
    />

  </div>


</template>

<script>
import TagItem from "@/views/components/elements/TagItem";
import OrderDialogItem from "@/views/components/elements/OrderDialogItem";
import {formPrice, generateUuidNo} from "@/util/helpers";


export default {
  name: "OrderDetailItem",
  components: {
    TagItem: TagItem,
    OrderDialogItem: OrderDialogItem,
  },
  props: {
    img: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0,
    },
    delivery_time: {
      type: String,
      default: '',
    },
    price_data: {
      type: Object,
      default: () => {},
    },
    tag_list: {
      type: Array,
      default: () => [],
    },
    total_price: {
      type: Number,
      default: 0,
    },
    price: {
      type: Number,
      default: 0,
    },
    discount: {
      type: Number,
      default: 0,
    },
    combine_buy_discount: {
      type: Number,
      default: 0,
    },
    combine_buy_amount: {
      type: Number,
      default: 0,
    },
    exchange_rate: {
      type: Number,
      default: 0,
    },
    decrease: {
      type: Number,
      default: 0,
    },
    stock: {
      type: Number,
      default: 0,
    },
    actual_stock: {
      type: Number,
      default: 0,
    },
    history_list:{
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      selectorDialog: "",

    };
  },
  created(){
    const randomNum = generateUuidNo();
    this.selectorDialog = `orderDialogItem-${randomNum}`;
  },
  methods:{
    formPrice(price_data){
      return formPrice(price_data);
    }
  }
}
</script>

<style scoped>
.imgSize {
  min-width: 46px;
  min-height: 46px;
}

.fit {
  object-fit: contain;
  /*aspect-ratio: 1;*/
}

.grid-gap {
  grid-gap: 10px;
}

</style>
